// Generated by /client/scripts/generate-icon-components.mjs
// DO NOT EDIT DIRECTLY

import type React from "react";

import home02Icon from "@/assets/icons/home-02.svg";

import { Icon, type IconProps } from "../Icon/Icon";

type Home02IconProps = Omit<IconProps, "name">;

export function Home02Icon(props: Home02IconProps): React.ReactNode {
  return <Icon name={home02Icon} {...props} />;
}
